import { bl_sfa_deal_calendar_event_RowClass } from "../../../dbschema/bl_sfa_deal_calendar_event.model";
import { BaseContainerModel } from "../../base-container.model";

export class SfaDealCalendarEventContainerModel extends BaseContainerModel {
    bl_sfa_deal_calendar_event: bl_sfa_deal_calendar_event_RowClass = new bl_sfa_deal_calendar_event_RowClass();
}